module.exports = __webpack_public_path__ + "img/1.449f943c.png";